import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
const without = ['2,500 workouts = 2,500 decisions', 'Bundles you download and never fully open', 'You still search, pick and sequence every week', 'No plan for rain, crowds or missing gear', 'Still eating your Sunday night'];
const withIt = ['One session per day, already assigned', '365-day calendar across 4 seasonal pillars', 'Swap tables for space, gear and injuries', 'Scripts for cueing, transitions and retention', "Open it before class and you're done"];
export function ValueStack() {
  return <section aria-labelledby="vs-heading" className="w-full bg-white" data-id="element-249" data-mp="297gxbmzr8gv6">
      <div className="max-w-4xl mx-auto px-5 py-16 sm:py-20" data-id="element-250" data-mp="2954gxe9naek8">
        <div className="text-center" data-id="element-251" data-mp="2d7r5n6b0rjd7">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-gold-deep" data-id="element-252" data-mp="2d6ptszm6isuf">
            Why this isn&apos;t another workout bundle
          </p>
          <h2 id="vs-heading" className="mt-3 font-display font-bold uppercase text-ink text-3xl sm:text-5xl" data-id="element-253" data-mp="35q50qy4z0r8l">
            A workout library vs{' '}
            <span className="text-crimson-deep" data-id="element-254" data-mp="1oh1o4qtlt9fj">a decided calendar</span>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-base text-ink-soft" data-id="element-255" data-mp="235odllcy3hkh">
            Every bundle on the market sells you more options. Options were never
            the problem — deciding what to run on Tuesday at 6 a.m. was.
          </p>
        </div>

        {/* Two columns at every width — never stacks */}
        <div className="mt-8 grid grid-cols-2 overflow-hidden rounded-2xl border border-ice-dark" data-id="element-256" data-mp="2850xbx8is8iu">
          <div className="bg-ice px-3.5 py-4 sm:p-6" data-id="element-257" data-mp="2m4abkrd60sk6">
            <h3 className="font-display text-base uppercase tracking-wide text-ink-soft sm:text-xl" data-id="element-258" data-mp="2m1o6cydqyp54">
              A $197 workout bundle
            </h3>
            <ul className="mt-3.5 grid gap-2.5" data-id="element-259" data-mp="rr2hx30xen04">
              {without.map(item => <li key={item} className="flex items-start gap-2 text-[12.5px] leading-snug text-ink-soft sm:text-sm" data-id="element-260" data-mp="mry7k929mj87">
                  <span className="mt-0.5 flex h-4 w-4 flex-none items-center justify-center rounded-full bg-crimson/15" data-id="element-261" data-mp="2rrz7il6abxsp">
                    <XIcon className="h-2.5 w-2.5 text-crimson-deep" aria-hidden="true" data-id="element-262" data-mp="2vtkpum1l94aa" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
          <div className="bg-navy px-3.5 py-4 text-white sm:p-6" data-id="element-263" data-mp="35qyzo2t0autm">
            <h3 className="font-display text-base uppercase tracking-wide text-gold sm:text-xl" data-id="element-264" data-mp="3aqv3o21pem96">
              Bootcamp Ready
            </h3>
            <ul className="mt-3.5 grid gap-2.5" data-id="element-265" data-mp="3fj4qvabfp87r">
              {withIt.map(item => <li key={item} className="flex items-start gap-2 text-[12.5px] font-medium leading-snug sm:text-sm" data-id="element-266" data-mp="3jidjgbuqn01q">
                  <span className="mt-0.5 flex h-4 w-4 flex-none items-center justify-center rounded-full bg-gold/20" data-id="element-267" data-mp="3th3061aweege">
                    <CheckIcon className="h-2.5 w-2.5 text-gold-hover" aria-hidden="true" data-id="element-268" data-mp="7h6p9urfrx8f" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}